import React, { useCallback, useEffect, useState } from 'react'


import axios from 'axios';

import { FaEdit, FaSearch, FaFileExcel, FaFilePdf, FaUpload, FaPlus, FaSave, FaEdit as FaEditIcon, FaBoxes, FaEye, FaEyeSlash } from 'react-icons/fa';

import '../Customcss/table.css'
import Puff from 'react-loading-icons/dist/esm/components/puff';
import { useStateContext } from '../Context/ContextProvider';
import { toast } from 'react-toastify';

function Product() {
 const{type,weburl}= useStateContext();
  const [isClick,setIsClick]=useState(false);
  const [isThisClick,setIsThisClick]=useState('');
    const [category,setCategory]=useState([]);
    const [distributer,setDistributer]=useState([]);
    const [defaultCategory,setDefaultCategory]=useState('');
    const [defaultStore,setDefaultStore]=useState('');
    const [defaultDistributer,setDefaultDistributer]=useState('');
    const [store,setStore]=useState([]);
    const [packsaleprice,setPackSalePrice]=useState('');
    const [packcostprice,setPackCostPrice]=useState('');
    
    const [unitsaleprice,setUnitSalePrice]=useState('');
    const [unitcostprice,setUnitCostPrice]=useState('');
    const [qty,setQty]=useState('1');
    const [pcs,setPcs]=useState('');
    const [packsize,setPackSize]=useState('1');
    const [packqty,setPackQty]=useState('1');
    const [unitretailprice,setUnitRetailPrice]=useState('');
    const [totalPages, setTotalPages] = useState(1);
    const [products,setProducts]=useState([]);
const [searchQuery,setSearchQuery]=useState('');
const [productid,setProductId]=useState('');
const [image, setImage] = useState(null);
const [imagePreview, setImagePreview] = useState(null);
const [imagePreviewEdit, setImagePreviewEdit] = useState(null);

const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage, setItemsPerPage] = useState(10);
const [serialStart, setSerialStart] = useState(1);

const [file, setFile] = useState(null);
const[batchId,setBatchId]=useState('');
const[progress,setProgess]=useState(1);
const [error,setError]=useState('');
const[isLoading,setIsLoading]=useState(false);
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmitImport = async (e) => {
      setIsLoading(true);
      e.preventDefault();

      const formData = new FormData();
      formData.append('file', file);

      try {
          const response = await axios.post('api/import/products', formData, {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
          });

          console.log('Response:', response.data);
          setBatchId(response.data.batchId);
          setIsLoading(false);
          setError(response.data.message);
          toast.success(response.data.message || 'File uploaded successfully!');
      } catch (error) {
          console.error('Error uploading file:', error);
          setError(error.message);
          setIsLoading(false);
          toast.error('Upload failed: ' + error.message);
      }
  };
  const updateProgress = useCallback(() => {
      if(batchId){
        axios.get(`api/batch/${batchId}`).then(response => {
          setProgess(response.data.progress);
          console.log(response.data);
        }).catch(err => console.log(err));
      }
    }, [batchId]);
    
    useEffect(() => {
      const fetchData = async () => {
        if (batchId && progress < 100) {
           updateProgress();
        }
      };
    
      fetchData();
    }, [batchId, progress, updateProgress]);

   


const HandleSetProductId=(e)=>{
  e.preventDefault();
 setInputProduct(defaultProductState);
  
  
  setPackSalePrice('');
  setPackQty('1');
  setPackCostPrice('');
  setProductId('');
  setUnitRetailPrice('');
  setPackSize('1');
  setPcs('');
  setQty('1');
  setImagePreview(null);
  setImagePreviewEdit(null);
  setImage(null);
  
    }
const handleSearchChange = (event) => {

  setSearchQuery(event.target.value);
  setCurrentPage(1);
};

const handleImageChange = (e) => {
  const file = e.target.files[0];

  if (file && file.size <= 20480) {
    setImage(file);

    const reader = new FileReader();
    reader.onload = (e) => {
      setImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);
  } else {
    toast.error('Image Size Should Be Less Than 20kb', {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      });
  }
};



useEffect(()=>{
 
  axios.get(`/api/view/products?page=${currentPage}&search=${searchQuery}`).then(response=>{
  
    setItemsPerPage(response.data.products.per_page);
    setProducts(response.data.products.data);
    setTotalPages(response.data.products.last_page);
  }).catch(err=>console.log(err));
 
  

},[currentPage,searchQuery,isThisClick,isClick]);





useEffect(() => {
  setSerialStart((currentPage - 1) * itemsPerPage + 1);
}, [currentPage, itemsPerPage]);


    const handlePackSalePrice=(e)=>{
setPackSalePrice(e.target.value);
setUnitSalePrice(parseFloat(e.target.value/packsize).toFixed(2));

    }
    const handlePackCostPrice=(e)=>{


      setPackCostPrice(e.target.value);
setUnitCostPrice(parseFloat(e.target.value/packsize).toFixed(2))

    }
   
    const handlePackSize=(e)=>{

setPackSize(e.target.value);

setQty(parseFloat(e.target.value===''?1:e.target.value)*parseFloat(packqty===''?0:packqty)+parseFloat(pcs===''?0:pcs))
setUnitCostPrice(parseFloat(packcostprice/parseFloat(e.target.value===''?1:e.target.value)).toFixed(2));
setUnitSalePrice(parseFloat(packsaleprice/parseFloat(e.target.value===''?1:e.target.value)).toFixed(2));

    }

    const handlePackQty=(e)=>{


      setPackQty(e.target.value);
setQty(parseInt(e.target.value===''?0:e.target.value*packsize)+parseInt(pcs===''?0:pcs))


    }

    const handleChangeUnitCostPrice=(e)=>{
setUnitCostPrice(e.target.value);
setPackCostPrice(parseFloat(e.target.value*packsize).toFixed(2));

    }
    const handleChangeUnitSalePrice=(e)=>{
      setUnitSalePrice(e.target.value);
      setPackSalePrice(parseFloat(e.target.value*packsize).toFixed(2));
      
          }
    const handlePcsChange=(e)=>{

const newqty=parseInt(e.target.value===''?0:e.target.value)+(parseInt(packqty===''?0:packqty)*parseInt(packsize===''?1:packsize));
setQty(newqty);
setPackQty(Math.floor(parseInt(newqty)/parseInt(packsize===''?1:packsize)));
setPcs(parseInt(newqty)%parseInt(packsize===''?1:packsize));


    }
   const handleQtyChange=(e)=>{
setQty(e.target.value);
setPackQty(Math.floor(parseInt(e.target.value===''?0:e.target.value)/parseInt(packsize===''?1:packsize)))
setPcs((parseInt(e.target.value===''?0:e.target.value)%parseInt(packsize===''?1:packsize)))


   }
    const defaultProductState = {
      name: '',
      alias: '',
      weight: '0',
      color: '',
      unit: 'Pcs',
      hold: '1',
      alert: '',
      aisle: '',
      bin: '',
      extraDiscount:'0',
      unitwholesaleprice: '',
      errorlist: {},
    };

    const [inputProduct,setInputProduct]=useState(defaultProductState);

    const handleInput=(e)=>{
        
e.preventDefault();


setInputProduct({...inputProduct,[e.target.name]:e.target.value});
    }

useEffect(()=>{
    axios.get(`/api/fetch/distributer`).then(response=>{
           
        setDistributer(response.data.user);
        if(response.data.user && response.data.user.length>0){
          setDefaultDistributer(response.data.user[0]['id']);
        }
    
      })


},[]);

useEffect(()=>{
       
    axios.get(`/api/fetch/category`).then(response=>{
       
      setCategory(response.data.category);
      if(response.data.category && response.data.category.length>0){
        setDefaultCategory(response.data.category[0]['id']);
      }
    
     
    })
    
    
 
 
  
  },[]);

useEffect(()=>{

    axios.get(`/api/fetch/store`).then(response=>{
           
        setStore(response.data.store);
        if(response.data.store && response.data.store.length>0){
          setDefaultStore(response.data.store[0]['id']);
        }
        
      })

},[]);


 
    

const handleSubmit = (e) => {
  setIsClick(true);
  e.preventDefault();

  const defaultData = {
    category_id: defaultCategory,
    distributer_id: defaultDistributer,
    store_id: defaultStore,
    pack_sale_price: packsaleprice,
    pack_cost_price: packcostprice,
    unitsaleprice: unitsaleprice,
    unitcostprice: unitcostprice,
    pack_size: packsize,
    pack_qty: packqty,
    qty: qty,
    unitretailprice:unitretailprice,
  };

  const formData = new FormData();
  if(image) formData.append('image', image);

  for (const key in defaultData) {
    if(defaultData[key] !== undefined && defaultData[key] !== null){
      formData.append(key, defaultData[key]);
    }
  }
  for (const key in inputProduct) {
    if(inputProduct[key] !== undefined && inputProduct[key] !== null){
      formData.append(key, inputProduct[key]);
    }
  }

  axios
    .post('api/add/product', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => {
      if (res.data.status === 200) {
        toast.success('Item Successfully Added!', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          });
          setInputProduct(defaultProductState);
  
  
  setPackSalePrice('');
  
  setPackQty('1');
  setPackCostPrice('');
  setProductId('');
  setUnitRetailPrice('');
  setImagePreview(null);
  setImage(null);
  
        setIsClick(false);
      }else if(res.data.status===400){
        toast.error(res.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          });
        setIsClick(false);
      }
      
      
      else {
        setInputProduct({ ...inputProduct, errorlist: res.data.validation_errors || {} });
        setIsClick(false);
      }
      setIsClick(false);

    }).catch(err=>{
      setIsClick(false);
      toast.error('Something went wrong!');
    });
};


const handleDelete=(e,id,index)=>{
setIsThisClick(index);
axios.delete(`api/delete/product/${id}`).then(res=>{
if(res.data.status===200){
  toast.success('Item Deleted Successfully!', {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    });
setIsThisClick('');
}else{

}

})


}
const handleEdit=(e,id,index)=>{
  e.preventDefault();
setIsThisClick(index);
setProductId(id);
axios.get(`api/edit/product/${id}`).then(res=>{

  setDefaultCategory(res.data.product.category_id);
setDefaultStore(res.data.product.store_id);
setDefaultDistributer(res.data.product.distributer_id);
setPackQty(Math.floor(res.data.product.qty/res.data.product.pack_size));

setPackSize(res.data.product.pack_size);
setQty(res.data.product.qty);
setPcs(res.data.product.qty%res.data.product.pack_size);
setPackSalePrice(res.data.product.pack_sale_price);
setPackCostPrice(res.data.product.pack_cost_price);
setUnitCostPrice(res.data.product.unitcostprice);
setUnitSalePrice(res.data.product.unitsaleprice);
setUnitRetailPrice(res.data.product.unitretailprice===null?'0':res.data.product.unitretailprice);
setImagePreview(null);

setImagePreviewEdit(res.data.product.image);
const updateitems={
...inputProduct,
'name':res.data.product.name===null?'':res.data.product.name,
'color':res.data.product.color===null?'':res.data.product.color,
'weight':res.data.product.weight===null?'':res.data.product.weight,
'unit':res.data.product.unit===null?'':res.data.product.unit,
'alert':res.data.product.productalert===null?'':res.data.product.productalert,
'hold':res.data.product.hold===null?'':res.data.product.hold,
'alias':res.data.product.alias===null?'':res.data.product.alias,
'aisle':res.data.product.class===null?'':res.data.product.class,
'bin':res.data.product.box===null?'':res.data.product.box,
'unitwholesaleprice':res.data.product.unitwholesaleprice===null?'0':res.data.product.unitwholesaleprice,
'extraDiscount':res.data.product.extra_discount===null?'0':res.data.product.extra_discount,
}


setInputProduct(updateitems);








setIsThisClick('');


});



}

const handleUpdate=(e)=>{
  setIsClick(true);
e.preventDefault();

const defaultData={

  'category_id':defaultCategory,
  'distributer_id':defaultDistributer,
  'store_id':defaultStore,
  'pack_sale_price':packsaleprice,
  'pack_cost_price':packcostprice,
  'unitsaleprice':unitsaleprice,
  'unitcostprice':unitcostprice,
  'pack_size':packsize,
  'pack_qty':packqty,
  'qty':qty,
  'unitretailprice':unitretailprice,
  'productid':productid,
  
  
  
  }
  
  const formData = new FormData();
  if(image) formData.append('image', image);

  for (const key in defaultData) {
    if(defaultData[key] !== undefined && defaultData[key] !== null){
      formData.append(key, defaultData[key]);
    }
  }
  for (const key in inputProduct) {
    if(inputProduct[key] !== undefined && inputProduct[key] !== null){
      formData.append(key, inputProduct[key]);
    }
  }
  axios.post('api/update/product', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then(res=>{
if(res.data.status===401){
setInputProduct({...inputProduct,errorlist:res.data.validation_errors || {}});
}
else if (res.data.status===400){

  
    toast.error(res.data.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      });
  setImagePreviewEdit(null);
  
}
else{
  toast.success('Item Updated Successfully!', {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    });
setImagePreviewEdit(null);
setImage(null);
}
setIsClick(false);


  }).catch(err=>{
    setIsClick(false);
    toast.error('Update failed!');
  });


}
const handleExport=()=>{
 setIsClick(true);
  axios({
    url: 'api/products/export',
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'products.xlsx');
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
    setIsClick(false);
    toast.success('Export started!');
  }).catch(err=>{
    setIsClick(false);
    toast.error('Export failed!');
  });



}

const handleExportPdf=()=>{
 setIsClick(true);

  axios({
    url: 'api/products/export/pdf',
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    window.open(url, '_blank');
    window.URL.revokeObjectURL(url);
   
   setIsClick(false);
  }).catch(err=>{
    setIsClick(false);
    toast.error('PDF export failed!');
  });



}

  return (
    <>
    <style>{`
      .product-container {
        padding: 20px;
        background: #f8f9fa;
        min-height: 100vh;
      }
      
      .max-width-container {
        max-width: 1400px;
        margin: 0 auto;
      }
      
      /* Card Styles */
      .form-card, .table-card {
        background: white;
        border-radius: 16px;
        box-shadow: 0 8px 30px rgba(0,0,0,0.12);
        margin-bottom: 30px;
        overflow: hidden;
        transition: all 0.3s ease;
      }
      
      .card-header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        padding: 15px 25px;
        color: white;
      }
      
      .card-header-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      
      .card-header-title {
        display: flex;
        align-items: center;
        gap: 12px;
      }
      
      .card-header-title h3 {
        margin: 0;
        font-weight: 600;
      }
      
      .add-new-btn {
     
      background: red;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 8px;
  margin-right:auto;  /* This pushes button to the right */
  padding: 8px 20px;
  color: white;
  cursor: pointer;
  transition: all 0.3s;
  display: block; 
      }
      
      .add-new-btn:hover {
        background: rgba(255,255,255,0.3);
      }
      
      .card-body {
        padding: 25px;
      }
      
      /* Form Grid */
      .form-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        gap: 20px;
      }
      
      .form-field {
        display: flex;
        flex-direction: column;
      }
      
      .form-label {
        font-size: 13px;
        color: #666;
        margin-bottom: 5px;
        display: block;
        font-weight: 500;
      }
      
      .form-input, .form-select {
        width: 100%;
        padding: 12px 15px;
        border: 1px solid #ddd;
        border-radius: 10px;
        font-size: 14px;
        transition: all 0.3s;
        background: white;
      }
      
      .form-input:focus, .form-select:focus {
        outline: none;
        border-color: #667eea;
        box-shadow: 0 0 0 3px rgba(102,126,234,0.1);
      }
      
      .form-input-disabled {
        background: #f5f5f5;
        cursor: not-allowed;
      }
      
      .error-text {
        color: #dc3545;
        font-size: 12px;
        margin-top: 5px;
      }
      
      .image-preview {
        width: 50px;
        height: 50px;
        border-radius: 8px;
        object-fit: cover;
        margin-top: 10px;
      }
      
      .image-preview-container {
        display: flex;
        gap: 10px;
        margin-top: 10px;
      }
      
      /* Button Styles */
      .btn-submit, .btn-update {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        border-radius: 10px;
        padding: 12px 40px;
        color: white;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 10px;
        transition: transform 0.2s;
      }
      
      .btn-submit:hover, .btn-update:hover {
        transform: translateY(-2px);
      }
      
      .btn-excel {
        background: #28a745;
        border: none;
        border-radius: 10px;
        padding: 10px 20px;
        color: white;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
      }
      
      .btn-pdf {
        background: #dc3545;
        border: none;
        border-radius: 10px;
        padding: 10px 20px;
        color: white;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
      }
      
      .btn-import {
        background: #17a2b8;
        border: none;
        border-radius: 10px;
        padding: 10px 20px;
        color: white;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
      }
      
      .btn-delete {
        background: #dc3545;
        border: none;
        border-radius: 8px;
        padding: 6px 12px;
        color: white;
        cursor: pointer;
      }
      
      .btn-delete:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
      
      .btn-edit {
        background: #ffc107;
        border: none;
        border-radius: 8px;
        padding: 6px 12px;
        color: #333;
        cursor: pointer;
      }
      
      .btn-pagination {
        background: #667eea;
        border: none;
        border-radius: 8px;
        padding: 8px 20px;
        color: white;
        cursor: pointer;
      }
      
      .btn-pagination:disabled {
        background: #ccc;
        cursor: not-allowed;
      }
      
      .form-actions {
        margin-top: 30px;
        display: flex;
        justify-content: flex-end;
        gap: 15px;
      }
      
      /* Toolbar */
      .toolbar {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        margin-bottom: 25px;
        justify-content: space-between;
        align-items: center;
      }
      
      .search-container {
        display: flex;
        gap: 15px;
        flex-wrap: wrap;
        flex: 1;
      }
      
      .search-box {
        position: relative;
        flex: 1;
        max-width: 300px;
      }
      
      .search-icon {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #999;
      }
      
      .search-input {
        width: 100%;
        padding: 10px 15px 10px 40px;
        border: 1px solid #ddd;
        border-radius: 10px;
        font-size: 14px;
      }
      
      .import-form {
        display: flex;
        gap: 10px;
        align-items: center;
      }
      
      .file-input {
        padding: 8px;
        border: 1px solid #ddd;
        border-radius: 8px;
      }
      
      .alert-success {
        background: #d4edda;
        color: #155724;
        padding: 10px;
        border-radius: 8px;
        margin-bottom: 15px;
      }
      
      /* Table Styles */
      .table-wrapper {
        overflow-x: auto;
      }
      
      .product-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
      }
      
      .product-table th {
        padding: 12px;
        text-align: left;
        background: #f8f9fa;
        border-bottom: 2px solid #dee2e6;
        font-weight: 600;
      }
      
      .product-table td {
        padding: 10px;
        border-bottom: 1px solid #eee;
      }
      
      .product-table tr:hover {
        background: #f8f9fa;
      }
      
      .badge-category {
        background: #e8eaf6;
        padding: 4px 10px;
        border-radius: 20px;
        font-size: 12px;
      }
      
      .barcode {
        background: #f0f0f0;
        padding: 4px 8px;
        border-radius: 6px;
        font-family: monospace;
        font-size: 12px;
      }
      
      .visible-badge {
        color: #28a745;
      }
      
      .hidden-badge {
        color: #dc3545;
      }
      
      .price-icon-green {
        font-size: 10px;
        color: #28a745;
      }
      
      .price-icon-blue {
        font-size: 10px;
        color: #17a2b8;
      }
      
      .price-icon-purple {
        font-size: 10px;
        color: #6f42c1;
      }
      
      .price-icon-red {
        font-size: 10px;
        color: #dc3545;
      }
      
      /* Pagination */
      .pagination-container {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 15px;
        margin-top: 25px;
      }
      
      .page-info {
        background: #f0f0f0;
        padding: 6px 15px;
        border-radius: 20px;
        font-weight: 500;
      }
      
      /* Low Stock Row */
      .row-low-stock {
        background-color: #ffebee;
      }
      
      .row-hidden {
        background-color: #ffcdd2;
      }
      
      /* Image Cell */
      .product-image {
        width: 45px;
        height: 45px;
        border-radius: 8px;
        object-fit: cover;
      }
    `}</style>
    
    <div className="product-container">
      <div className="max-width-container">
        
        {/* Product Form Card */}
        <div className="form-card">
          <div className="card-header">
            <div className="card-header-content">
              <div className="card-header-title">
                {productid ? 
                
                 <button className="add-new-btn" >
                 <FaEditIcon size={24} />
                </button>
                 :  <button className="add-new-btn" onClick={(e)=>HandleSetProductId(e)}>
                   <FaPlus size={24}/>
                </button>}
               
              </div>
              
            </div>
          </div>
          
          <div className="card-body">
            {!productid ? (
              <form encType="multipart/form-data" onSubmit={handleSubmit} method='post'>
                <div className="form-grid">
                  <div className="form-field">
                    <label className="form-label">Product Name *</label>
                    <input type="text" name="name" placeholder="Enter product name" 
                      value={inputProduct.name} onChange={(e)=>handleInput(e)}
                      className="form-input" />
                    <span className="error-text">{inputProduct.errorlist?.name}</span>
                  </div>
                  <div className="form-field">
                    <label className="form-label">Product Color</label>
                    <input type="text" name="color" disabled placeholder="Product color" 
                      value={inputProduct.color} onChange={(e)=>handleInput(e)}
                      className="form-input form-input-disabled" />
                  </div>
                  <div className="form-field">
                    <label className="form-label">Product Weight</label>
                    <input type="number" disabled name="weight" placeholder="Product weight" 
                      value={inputProduct.weight} onChange={(e)=>handleInput(e)}
                      className="form-input form-input-disabled" />
                  </div>
                  
                  <div className="form-field">
                    <label className="form-label">Cotton (Pack Qty)</label>
                    <input type="number" name="pack_qty" placeholder='Pack quantity' 
                      value={packqty} onChange={(e)=>handlePackQty(e)}
                      className="form-input" />
                  </div>
                  <div className="form-field">
                    <label className="form-label">Size</label>
                    <input type="number" disabled name="pack_size" placeholder='Pack size' 
                      value={packsize} onChange={(e)=>handlePackSize(e)}
                      className="form-input form-input-disabled" />
                  </div>
                  <div className="form-field">
                    <label className="form-label">Pcs</label>
                    <input type="number" disabled name="pcs" placeholder='Pcs' 
                      value={pcs} onChange={(e)=>handlePcsChange(e)}
                      className="form-input form-input-disabled" />
                  </div>
                  
                  <div className="form-field">
                    <label className="form-label">Total Quantity *</label>
                    <input type="number" name="qty" placeholder='Quantity' 
                      value={qty} onChange={(e)=>handleQtyChange(e)}
                      className="form-input" />
                  </div>
                  <div className="form-field">
                    <label className="form-label">Qty Alert</label>
                    <input type="number" name="alert" placeholder='Alert threshold' 
                      value={inputProduct.alert} onChange={handleInput}
                      className="form-input" />
                  </div>
                  <div className="form-field">
                    <label className="form-label">Cotton Sale Price</label>
                    <input type="number" disabled name="pack_sale_price" placeholder='Pack sale price' 
                      value={packsaleprice} onChange={(e)=>handlePackSalePrice(e)}
                      className="form-input form-input-disabled" />
                    <span className="error-text">{inputProduct.errorlist?.pack_sale_price}</span>
                  </div>
                  
                  <div className="form-field">
                    <label className="form-label">Cotton Cost Price</label>
                    <input type="number" disabled name="pack_cost_price" placeholder='Pack cost price' 
                      value={packcostprice} onChange={(e)=>handlePackCostPrice(e)}
                      className="form-input form-input-disabled" />
                    <span className="error-text">{inputProduct.errorlist?.pack_cost_price}</span>
                  </div>
                  <div className="form-field">
                    <label className="form-label">Unit Cost Price</label>
                    <input type="number" name="unitcostprice" placeholder='Unit cost price' 
                      value={unitcostprice} onChange={(e)=>handleChangeUnitCostPrice(e)}
                      className="form-input" />
                  </div>
                  <div className="form-field">
                    <label className="form-label">Unit Sale Price</label>
                    <input type="number" name="unitsaleprice" placeholder='Unit sale price' 
                      value={unitsaleprice} onChange={(e)=>handleChangeUnitSalePrice(e)}
                      className="form-input" />
                  </div>
                  
                  <div className="form-field">
                    <label className="form-label">Super Wholesale Price</label>
                    <input type="number" value={unitretailprice} name="unitretailprice" placeholder='Super wholesale price' 
                      onChange={(e)=>setUnitRetailPrice(e.target.value)}
                      className="form-input" />
                    <span className="error-text">{inputProduct.errorlist?.unitretailprice}</span>
                  </div>
                  <div className="form-field">
                    <label className="form-label">Dragon Price</label>
                    <input type="text" name="unitwholesaleprice" placeholder="Dragon wholesale price" 
                      value={inputProduct.unitwholesaleprice} onChange={(e)=>handleInput(e)}
                      className="form-input" />
                    <span className="error-text">{inputProduct.errorlist?.unitwholesaleprice}</span>
                  </div>
                  <div className="form-field">
                    <label className="form-label">Extra Discount</label>
                    <input type="text" name="extraDiscount" placeholder="Extra discount" 
                      value={inputProduct.extraDiscount} onChange={(e)=>handleInput(e)}
                      className="form-input" />
                    <span className="error-text">{inputProduct.errorlist?.extraDiscount}</span>
                  </div>
                  
                  <div className="form-field">
                    <label className="form-label">Product Unit</label>
                    <select name='unit' value={inputProduct.unit} onChange={(e)=>handleInput(e)} className="form-select">
                      <option value="Pcs">Pcs</option><option value="Box">Box</option><option value="Carton">Carton</option>
                      <option value="Patta">Patta</option><option value="Rule">Rule</option><option value="Ml">Ml</option>
                      <option value="Tube">Tube</option><option value="Jar">Jar</option><option value="Pouch">Pouch</option>
                      <option value="Dozan">Dozan</option>
                      <option value="Pkt">Pkt</option>
                      <option value="Dasta">Dasta</option>
                      <option value="Dabi">Dabi</option>
                      <option value="Bundal">Bundal</option>
                    </select>
                  </div>
                  <div className="form-field">
                    <label className="form-label">Product Category</label>
                    <select name='category_id' onChange={(e)=>setDefaultCategory(e.target.value)} className="form-select" value={defaultCategory}>
                      {category && category.map(item => (<option key={item.id} value={item.id}>{item.name}</option>))}
                    </select>
                  </div>
                  <div className="form-field">
                    <label className="form-label">Distributer Name</label>
                    <select name='distributer_id' onChange={(e)=>setDefaultDistributer(e.target.value)} className="form-select" value={defaultDistributer}>
                      {distributer && distributer.map(item => (<option key={item.id} value={item.id}>{item.name}</option>))}
                    </select>
                  </div>
                  
                  <div className="form-field">
                    <label className="form-label">Store Name</label>
                    <select name='store_id' onChange={(e)=>setDefaultStore(e.target.value)} className="form-select" value={defaultStore}>
                      {store && store.map(item => (<option key={item.id} value={item.id}>{item.name}</option>))}
                    </select>
                  </div>
                  <div className="form-field">
                    <label className="form-label">Product Aisle</label>
                    <input type="text" disabled name="aisle" placeholder="Aisle" 
                      value={inputProduct.aisle} onChange={(e)=>handleInput(e)}
                      className="form-input form-input-disabled" />
                  </div>
                  <div className="form-field">
                    <label className="form-label">Product Bin</label>
                    <input type="text" disabled name="bin" placeholder="Bin" 
                      value={inputProduct.bin} onChange={(e)=>handleInput(e)}
                      className="form-input form-input-disabled" />
                  </div>
                  
                  <div className="form-field">
                    <label className="form-label">Product Visibility</label>
                    <select value={inputProduct.hold} name='hold' onChange={(e)=>handleInput(e)} className="form-select">
                      <option value="1">Visible</option><option value="2">Hidden</option>
                    </select>
                  </div>
                  <div className="form-field">
                    <label className="form-label">Product Barcode</label>
                    <input type="text" name="alias" placeholder="Barcode" 
                      value={inputProduct.alias} onChange={(e)=>handleInput(e)}
                      className="form-input" />
                    <span className="error-text">{inputProduct.errorlist?.alias}</span>
                  </div>
                  <div className="form-field">
                    <label className="form-label">Product Image (Max 20KB)</label>
                    <input type="file" accept="image/*" onChange={handleImageChange} className="file-input" />
                    {imagePreview && <img src={imagePreview} alt="Preview" className="image-preview" />}
                  </div>
                </div>
                
                <div className="form-actions">
                  <button type='submit' className="btn-submit">
                    {isClick ? <Puff height={20} stroke='white' strokeOpacity={1}/> : <><FaSave /> Save Product</>}
                  </button>
                </div>
              </form>
            ) : (
              <form encType="multipart/form-data" onSubmit={handleUpdate} method='post'>
                <div className="form-grid">
                  <div className="form-field"><label className="form-label">Product Name *</label><input type="text" name="name" value={inputProduct.name} onChange={(e)=>handleInput(e)} className="form-input" /><span className="error-text">{inputProduct.errorlist?.name}</span></div>
                  <div className="form-field"><label className="form-label">Product Color</label><input type="text" disabled name="color" value={inputProduct.color} onChange={(e)=>handleInput(e)} className="form-input form-input-disabled" /></div>
                  <div className="form-field"><label className="form-label">Product Weight</label><input type="number" disabled name="weight" value={inputProduct.weight} onChange={(e)=>handleInput(e)} className="form-input form-input-disabled" /></div>
                  <div className="form-field"><label className="form-label">Cotton (Pack Qty)</label><input type="number" name="pack_qty" value={packqty} onChange={(e)=>handlePackQty(e)} className="form-input" /></div>
                  <div className="form-field"><label className="form-label">Size</label><input type="number" disabled name="pack_size" value={packsize} onChange={(e)=>handlePackSize(e)} className="form-input form-input-disabled" /></div>
                  <div className="form-field"><label className="form-label">Pcs</label><input type="number" disabled name="pcs" value={pcs} onChange={(e)=>handlePcsChange(e)} className="form-input form-input-disabled" /></div>
                  <div className="form-field"><label className="form-label">Total Quantity</label><input type="number" name="qty" value={qty} onChange={(e)=>handleQtyChange(e)} className="form-input" /></div>
                  <div className="form-field"><label className="form-label">Qty Alert</label><input type="number" name="alert" value={inputProduct.alert} onChange={handleInput} className="form-input" /></div>
                  <div className="form-field"><label className="form-label">Pack Retail Price</label><input type="number" disabled name="pack_sale_price" value={packsaleprice} onChange={(e)=>handlePackSalePrice(e)} className="form-input form-input-disabled" /><span className="error-text">{inputProduct.errorlist?.pack_sale_price}</span></div>
                  <div className="form-field"><label className="form-label">Pack Cost Price</label><input type="number" disabled name="pack_cost_price" value={packcostprice} onChange={(e)=>handlePackCostPrice(e)} className="form-input form-input-disabled" /><span className="error-text">{inputProduct.errorlist?.pack_cost_price}</span></div>
                  <div className="form-field"><label className="form-label">Unit Cost Price</label><input type="number" name="unitcostprice" value={unitcostprice} onChange={(e)=>handleChangeUnitCostPrice(e)} className="form-input" /></div>
                  <div className="form-field"><label className="form-label">Unit Sale Price</label><input type="number" name="unitsaleprice" value={unitsaleprice} onChange={(e)=>handleChangeUnitSalePrice(e)} className="form-input" /></div>
                  <div className="form-field"><label className="form-label">Super Wholesale Price</label><input type="number" value={unitretailprice} name="unitretailprice" onChange={(e)=>setUnitRetailPrice(e.target.value)} className="form-input" /></div>
                  <div className="form-field"><label className="form-label">Dragon Price</label><input type="text" name="unitwholesaleprice" value={inputProduct.unitwholesaleprice} onChange={(e)=>handleInput(e)} className="form-input" /></div>
                  <div className="form-field"><label className="form-label">Extra Discount</label><input type="text" name="extraDiscount" value={inputProduct.extraDiscount} onChange={(e)=>handleInput(e)} className="form-input" /></div>
                  <div className="form-field"><label className="form-label">Product Unit</label><select value={inputProduct.unit} name='unit' onChange={(e)=>handleInput(e)} className="form-select"><option value="Pcs">Pcs</option><option value="Box">Box</option><option value="Carton">Carton</option><option value="Patta">Patta</option><option value="Rule">Rule</option><option value="Ml">Ml</option><option value="Tube">Tube</option><option value="Jar">Jar</option><option value="Pouch">Pouch</option><option value="Dozan">Dozan</option><option value="Pkt">Pkt</option><option value="Dasta">Dasta</option><option value="Dabi">Dabi</option><option value="Bundal">Bundal</option></select></div>
                  <div className="form-field"><label className="form-label">Product Category</label><select value={defaultCategory} onChange={(e)=>setDefaultCategory(e.target.value)} className="form-select">{category && category.map(item => (<option key={item.id} value={item.id}>{item.name}</option>))}</select></div>
                  <div className="form-field"><label className="form-label">Distributer</label><select value={defaultDistributer} onChange={(e)=>setDefaultDistributer(e.target.value)} className="form-select">{distributer && distributer.map(item => (<option key={item.id} value={item.id}>{item.name}</option>))}</select></div>
                  <div className="form-field"><label className="form-label">Store</label><select value={defaultStore} onChange={(e)=>setDefaultStore(e.target.value)} className="form-select">{store && store.map(item => (<option key={item.id} value={item.id}>{item.name}</option>))}</select></div>
                  <div className="form-field"><label className="form-label">Aisle</label><input type="text" disabled name="aisle" value={inputProduct.aisle} onChange={(e)=>handleInput(e)} className="form-input form-input-disabled" /></div>
                  <div className="form-field"><label className="form-label">Bin</label><input type="text" disabled name="bin" value={inputProduct.bin} onChange={(e)=>handleInput(e)} className="form-input form-input-disabled" /></div>
                  <div className="form-field"><label className="form-label">Visibility</label><select value={inputProduct.hold} name='hold' onChange={(e)=>handleInput(e)} className="form-select"><option value="1">Visible</option><option value="2">Hidden</option></select></div>
                  <div className="form-field"><label className="form-label">Barcode</label><input type="text" name="alias" value={inputProduct.alias} onChange={(e)=>handleInput(e)} className="form-input" /></div>
                  <div className="form-field">
                    <label className="form-label">Product Image</label>
                    <input type="file" accept="image/*" onChange={handleImageChange} className="file-input" />
                    <div className="image-preview-container">
                      {imagePreviewEdit && <img src={`${weburl}${imagePreviewEdit}`} alt="Preview" className="image-preview" />}
                      {imagePreview && <img alt='uploaded' src={imagePreview} className="image-preview" />}
                    </div>
                  </div>
                </div>
                <div className="form-actions">
                  <button type='submit' className="btn-update">
                    {isClick ? <Puff height={20} stroke='white'/> : <><FaSave /> Update Product</>}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>

        {/* Products Table Card */}
        <div className="table-card">
          <div className="card-header">
            <h3 style={{margin:0,fontWeight:'600'}}>Products Inventory</h3>
          </div>
          
          <div className="card-body">
            {/* Toolbar */}
            <div className="toolbar">
              <div className="search-container">
                <div className="search-box">
                  <FaSearch className="search-icon" />
                  <input type="text" placeholder='Search products...' value={searchQuery} onChange={handleSearchChange}
                    className="search-input" />
                </div>
                <button onClick={handleExport} className="btn-excel">
                  <FaFileExcel /> Excel
                </button>
                <button onClick={handleExportPdf} className="btn-pdf">
                  <FaFilePdf /> PDF
                </button>
              </div>
              
              <div>
                <form onSubmit={handleSubmitImport} className="import-form">
                  <input type="file" onChange={handleFileChange} className="file-input" />
                  <button type="submit" className="btn-import">
                    <FaUpload /> {isLoading ? 'Uploading...' : 'Import'}
                  </button>
                </form>
              </div>
            </div>
            {error && <div className="alert-success"><FaBoxes style={{marginRight:'8px'}}/>{error}</div>}
            
            {/* Table */}
            <div className="table-wrapper">
              <table className="product-table">
                <thead>
                  <tr>
                    <th>Sr</th><th>Name</th><th>Image</th>
                    <th>Barcode</th><th>Aisle</th><th>Bin</th>
                    <th>Visibility</th><th>Color</th><th>Unit</th>
                    <th>Qty</th><th>Sale Price</th><th>Super Wholesale</th>
                    <th>Dragon Price</th><th>Cost Price</th><th>Category</th>
                    <th>Store</th><th>Distributer</th><th>Delete</th><th>Edit</th>
                   </tr>
                </thead>
                <tbody>
                  {products && products.map((item,index)=>(
                    <tr key={item.id} className={item.qty < item.alert ? 'row-low-stock' : (item.hold === '2' ? 'row-hidden' : '')}>
                      <td>{serialStart+index}</td>
                      <td style={{fontWeight:'500'}}>{item.name?.length > 20 ? `${item.name.slice(0, 20)}...` : item.name}</td>
                      <td><img width={45} height={45} alt='product' src={`${weburl}${item.image}`} className="product-image" /></td>
                      <td><span className="barcode">{item.alias}</span></td>
                      <td>{item.class}</td><td>{item.box}</td>
                      <td>{item.hold === '1' ? <span className="visible-badge"><FaEye /> Visible</span> : <span className="hidden-badge"><FaEyeSlash /> Hidden</span>}</td>
                      <td>{item.color}</td><td>{item.unit}</td>
                      <td style={{fontWeight:'bold'}}>{item.qty}</td>
                      <td> {item.unitsaleprice}</td>
                      <td> {item.unitretailprice}</td>
                      <td> {item.unitwholesaleprice}</td>
                      <td> {item.unitcostprice}</td>
                      <td><span className="badge-category">{item.categoryname}</span></td>
                      <td>{item.storename}</td><td>{item.distributername}</td>
                      <td style={{textAlign:'center'}}>
                       <button disabled={type !== 'Managment'} onClick={(e) => handleDelete(e,item.id,index)} className="btn-delete"></button>
                      </td>
                      <td style={{textAlign:'center'}}>
                        <button onClick={(e)=>handleEdit(e,item.id,index)} className="btn-edit">
                          {isThisClick === index ? <Puff height={14} width={14}/> : <FaEdit />}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            {/* Pagination */}
            <div className="pagination-container">
              <button disabled={currentPage === 1} onClick={() => setCurrentPage((page) => page - 1)} className="btn-pagination">
                Previous
              </button>
              <span className="page-info">{currentPage} of {totalPages}</span>
              <button disabled={currentPage === totalPages} onClick={() => setCurrentPage((page) => page + 1)} className="btn-pagination">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default Product